import { z } from "zod";
const configSchema = z.object({
    apiUrl: z.string().url('VITE_API_URL must be a valid URL'),
    eaasApiUrl: z.string().url('VITE_EAAS_API_URL must be a valid URL'),
    useMockApi: z.boolean().default(false),
    aws: z.object({
        region: z.string().default('us-east-1'),
        s3: z.object({
            changelogBucket: z.string(),
            endpoint: z.string().optional()
        }),
        dynamodb: z.object({
            changelogTable: z.string(),
            endpoint: z.string().optional()
        })
    })
});
function validateConfig() {
    const useMockApi = import.meta.env.VITE_USE_MOCK_API === 'true';
    const isDevelopment = import.meta.env.MODE === 'development';
    // LocalStack configuration when using mocks
    const localStackEndpoint = 'http://localhost:4566';
    const rawConfig = {
        apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:5173/api',
        eaasApiUrl: import.meta.env.VITE_EAAS_API_URL || (isDevelopment ? 'https://eaas-dev.qrypt.com/api/v1/entropy' : 'https://eaas-aws.qrypt.com/api/v1/entropy'),
        useMockApi,
        aws: {
            region: useMockApi ? 'us-east-1' : import.meta.env.VITE_AWS_REGION || 'us-east-1',
            s3: {
                changelogBucket: useMockApi ? 'changelog-files-dev' : import.meta.env.VITE_S3_CHANGELOG_BUCKET || '',
                endpoint: useMockApi ? localStackEndpoint : undefined
            },
            dynamodb: {
                changelogTable: useMockApi ? 'Changelog' : import.meta.env.VITE_DYNAMODB_CHANGELOG_TABLE || '',
                endpoint: useMockApi ? localStackEndpoint : undefined
            }
        }
    };
    try {
        return configSchema.parse(rawConfig);
    } catch (error) {
        if (error instanceof z.ZodError) {
            const errorMessages = error.errors.map((err)=>`${err.path.join('.')}: ${err.message}`).join('\n');
            throw new Error(`Environment configuration validation failed:\n${errorMessages}`);
        }
        throw error;
    }
}
export const config = validateConfig();
